function findModal(id) {
  return id ? document.getElementById(id) : null
}

export function openModal(id, trigger = null) {
  dispatchToModal(id, new CustomEvent("website:modal:open", { detail: { trigger } }))
}

export function closeModal(id) {
  dispatchToModal(id, new CustomEvent("website:modal:close"))
}

function dispatchToModal(id, event) {
  const modal = findModal(id)
  if (!modal) return

  if (modal.dataset.modalControllerReady === "true") {
    modal.dispatchEvent(event)
  } else {
    modal.addEventListener("website:modal:connected", () => modal.dispatchEvent(event), { once: true })
  }
}
